(function () {
  'use strict';

  /* Scroll animations */
  var animated = document.querySelectorAll('.lb-animate');
  if (animated.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    animated.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    animated.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* Promo bar height for sticky header offset */
  var promoBar = document.querySelector('.promo-bar');
  if (promoBar && promoBar.offsetParent !== null) {
    document.documentElement.style.setProperty('--lb-promo-height', promoBar.offsetHeight + 'px');
  } else {
    document.documentElement.style.setProperty('--lb-promo-height', '0px');
  }

  /* Promo bar close */
  if (promoBar) {
    var closeBtn = promoBar.querySelector('.promo-close');
    if (localStorage.getItem('lb_promo_closed') === '1') {
      promoBar.style.display = 'none';
      document.documentElement.style.setProperty('--lb-promo-height', '0px');
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        promoBar.style.display = 'none';
        localStorage.setItem('lb_promo_closed', '1');
        document.documentElement.style.setProperty('--lb-promo-height', '0px');
      });
    }
  }

  /* Wishlist toggle */
  document.querySelectorAll('.lb-product-card__wishlist').forEach(function (btn) {
    var productId = btn.dataset.productId;
    if (productId && localStorage.getItem('lb_wish_' + productId) === '1') {
      btn.classList.add('is-active');
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!productId) return;
      var key = 'lb_wish_' + productId;
      var active = btn.classList.toggle('is-active');
      if (active) {
        localStorage.setItem(key, '1');
      } else {
        localStorage.removeItem(key);
      }
    });
  });

  /* Header scroll state */
  var header = document.querySelector('header-component');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Subtle hero parallax */
  var hero = document.querySelector('.lb-hero');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (hero && !reduceMotion) {
    var ticking = false;
    var updateHeroDepth = function () {
      var rect = hero.getBoundingClientRect();
      var progress = Math.min(Math.max(rect.top * -1, 0), hero.offsetHeight);
      hero.style.setProperty('--lb-hero-parallax', progress * 0.035 + 'px');
      ticking = false;
    };

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeroDepth);
        ticking = true;
      }
    }, { passive: true });
    updateHeroDepth();
  }
})();
